module.exports = __webpack_public_path__ + "img/JO.17530dec.svg";